import './main.less';
import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';

import TextField from '../../../shared/form-elements/textarea';
import ModalBox from '../../../shared/modal';

const Form = props => (
	<form action=""
		className="ui-form ext-close-threads-form"
		onSubmit={props.handleSubmit(data => props.formSubmit(data))}
	>
		<div className="ui-form__element">
			<Field name="closeMessage" autoFocus={true} placeholder={props.intl('Message')} component={TextField} />
		</div>

		<div className="ui-form__element buttons-wrap">
			<button className="ui-btn ui-btn-primary">{props.intl('Apply')}</button>
		</div>
	</form>
);

Form.propTypes = {
	intl: PropTypes.func,
	handleSubmit: PropTypes.func,
	formSubmit: PropTypes.func
};

const Main = props => {
	return <ModalBox
		title={props.intl('Close current thread')}
		body={Form(props)}
		isOpen={props.closeFormShouldShowStatus}
		onClose={props.toggleCloseForm}
		className="form-modal"
	/>;
};

Main.propTypes = {
	intl: PropTypes.func,
	closeFormShouldShowStatus: PropTypes.bool,
	toggleCloseForm: PropTypes.func
};

export default reduxForm({
	form: 'threadCloseForm'
})(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/external-threads/components/close-form/main.js